<template>
  <div class="printers-table__item">
    <div class="top-bar">
      <div class="top-bar--left">
        <h4>
          <printer-status :printer="printer"></printer-status>
          {{calculatePrinterName(printer)}} <span class="model">{{printer.description}}</span>
        </h4>
      </div>
      <div class="top-bar--right">
        <b-button size="-small" variant="-primary" @click="handleDeletePrinter">{{$t('printers.inactive.delete')}}</b-button>
        <b-button size="-small" variant="-secondary" @click="handleUnhidePrinter">{{$t('printers.inactive.unhide')}}</b-button>
      </div>
    </div>

    <b-modal v-model="openDeletePrinter" size="lg">
      <delete-printer-confirmation ref="deletePrinterComponent" :printer="printer"></delete-printer-confirmation>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.cancel')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="$refs['deletePrinterComponent'].handleDeletePrinter()">
            {{$t('printers.modal.confirmDeletePrinter.delete')}}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {mapActions} from "vuex";
  import PrinterMixin from "@/mixins/printer";

  import PrinterStatus from "./printer/PrinterStatus";
  import DeletePrinterConfirmation from "./modal/DeletePrinterConfirmation";

  export default {
    name: 'inactive-printer-item',
    props: ['printer'],
    mixins: [PrinterMixin],
    components: {
      PrinterStatus,
      DeletePrinterConfirmation
    },
    data() {
      return {
        processing: false,
        openDeletePrinter: false
      }
    },
    methods: {
      ...mapActions(['restorePrinter']),

      handleUnhidePrinter() {
        this.processing = true;
        this.restorePrinter(this.printer.printer_id).then(({data}) => {
          this.processing = false;
          if (!data.result) {
            this.msgBoxOk(data.message, {title: 'Restore printer error'});
          }
        }).catch(() => {
          this.processing = false;
          this.msgBoxOk('Failed to restore printer', {title: 'Restore printer error'});
        });
      },

      handleDeletePrinter() {
        this.openDeletePrinter = true;
      }
    }
  }
</script>